import FormControl, { type FormControlProps } from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput, {
  type OutlinedInputProps,
} from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { formatCurrency, formatNumber } from '@/utils/strings';
import { getPrice, styles } from './utils';

export type PriceInputProps<N extends string> = {
  disabled?: boolean;
  sx?: FormControlProps['sx'];
  className?: string;
  size?: 'small' | 'medium';
  name: N;
  label: string;
  value: string;
  onChange: (value: string) => void;
};

export default function PriceInput<N extends string>({
  disabled,
  sx = {},
  className,
  name = 'price' as N,
  size = 'medium',
  label = 'Price',
  value,
  onChange,
}: PriceInputProps<N>) {
  const currency = 'EUR'; // TODO

  const handleChange: OutlinedInputProps['onChange'] = (e) => {
    onChange(getPrice(e.target.value, value));
  };

  return (
    <FormControl
      fullWidth
      disabled={disabled}
      className={className}
      sx={{ ...styles.formControl, ...sx }}>
      <InputLabel htmlFor={`price-input_${name}`}>{label}</InputLabel>
      <OutlinedInput
        id={`price-input_${name}`}
        size={size}
        inputProps={{
          pattern: '[0-9\s,\.]*',
        }}
        placeholder={formatNumber(1234.56)}
        startAdornment={
          <InputAdornment position="start">
            {formatCurrency(currency)}
          </InputAdornment>
        }
        label={label}
        value={value}
        onChange={handleChange}
      />
    </FormControl>
  );
}
